<template>
  <div>
    <el-popover
      ref="popoverRef"
      placement="bottom"
      width="660"
      trigger="click"
      @hide="handleHide"
    >
      <div slot="reference" class="" @click="downloadShow()">
        <vab-icon icon="download-line" />
        <span class="" style="cursor: pointer">下载</span>
      </div>
      <div class="footer">
        <el-button
          size="mini"
          circle
          icon="el-icon-refresh"
          @click="getList()"
        />
      </div>
      <div style="height: 484px; overflow: auto">
        <el-table
          v-loading="tableLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.4)"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column prop="createTime" label="下载时间" width="160" />
          <el-table-column prop="fileName" label="表格名称" width="" />
          <el-table-column label="操作" width="50">
            <template slot-scope="scope">
              <div
                v-if="isFail(scope.row.createTime) && scope.row.fileStatus == 0"
              >
                <i
                  class="messageList-item-download el-icon-circle-close"
                  style="color: red"
                ></i>
              </div>
              <div v-else>
                <i
                  v-if="!scope.row.loading"
                  class="messageList-item-download el-icon-download"
                  @click="download(scope.row)"
                ></i>
                <i v-else class="messageList-item-download el-icon-loading"></i>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-pagination
        v-show="total > 0"
        class="mt10 mb10"
        style="text-align: right"
        background
        :page-sizes="[10, 20, 30, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :pager-count="5"
        :size="queryParams.pageSize"
        :current-page="queryParams.pageNum"
        :auto-scroll="false"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </el-popover>
  </div>
</template>

<script>
  import axios from 'axios'
  import { downloadList, downloadLoading } from '@/api/index'
  export default {
    name: 'VabNotice',
    data() {
      return {
        messageShow: false,
        tableLoading: false,
        total: 0,
        queryParams: {
          pageNum: 1,
          pageSize: 10,
        },
        tableData: [],
        timer: null,
      }
    },
    created() {},
    mounted() {},
    methods: {
      downloadShow() {
        this.getList()
      },
      getList() {
        this.stopTimer()
        downloadList(this.queryParams).then((res) => {
          this.tableData = res.data.list
          this.total = parseInt(res.data.total)
          let ids = []

          this.tableData.forEach((item) => {
            if (!this.isFail(item.createTime) && item.fileStatus == 0) {
              this.$set(item, 'loading', true)
              this.$forceUpdate()
            }

            if (item.fileStatus == 0 && !this.isFail(item.createTime)) {
              ids.push(item.fileId)
            }
          })
          if (ids.length != 0) {
            this.startTimer(ids) //开启l轮询
          } else {
            this.stopTimer() // 停止轮询
          }
        })
      },
      startTimer(ids) {
        this.timer = setInterval(() => {
          this.getdownloadLoading(ids)
        }, 2000)
      },
      stopTimer() {
        clearInterval(this.timer)
      },
      handleHide() {
        this.stopTimer()
      },
      getdownloadLoading(id) {
        downloadLoading(id).then((res) => {
          if (id.length != res.data.length) {
            this.getList()
          }
        })
      },
      handlePageChange(val) {
        this.queryParams.pageNum = val
        this.getList()
      },
      handleSizeChange(val) {
        this.queryParams.pageSize = val
        this.queryParams.pageNum = 1
        this.getList()
      },
      isFail(time) {
        // 将给定的时间转换为 Date 对象
        const givenDate = new Date(time)

        // 获取当前时间
        const currentDate = new Date()
        // 计算两个时间之间的差值（以毫秒为单位）
        const timeDifference = currentDate - givenDate
        // 将毫秒转换为分钟
        const minutesDifference = timeDifference / (1000 * 60)

        // 判断是否超过 5 分钟
        if (minutesDifference > 5) {
          return true
        } else {
          return false
        }
      },
      download(row) {
        let { filePath, fileName } = row
        this.$set(row, 'loading', true)
        axios
          .get(filePath, {
            responseType: 'blob',
            timeout: 120000,
          })
          .then((res) => {
            setTimeout(() => {
              // 延时一秒关闭加载动画
              this.$set(row, 'loading', false)
            }, 1000)

            let url = window.URL.createObjectURL(new Blob([res.data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)

            link.click()
            this.$refs.popoverRef.doShow()
          })
      },
    },
  }
</script>

<style lang="scss" scoped>
  :deep() {
    .el-tabs__active-bar {
      min-width: 28px;
    }
  }

  .content {
    position: relative;
    font-size: 14px;
    .handleText {
      cursor: pointer;
      position: relative;
    }
  }
  .redNum {
    color: #fff;
    background: red;
    border-radius: 50%;
    position: absolute;
    width: 14px;
    height: 14px;
    line-height: 14px;
    text-align: center;
    font-size: 12px;
    top: 8px;
    right: -10px;
  }
  .messageList {
    background: #fff;
    top: 52px;
    right: 0;
    z-index: 999;

    .messageFooter {
      cursor: pointer;
      background: #eee;
      width: 100%;
      height: 44px;
      line-height: 44px;
      text-align: center;
      position: absolute;
      bottom: -40px;
    }
    .messageList-item {
      height: 44px;
      line-height: 44px;
      padding-left: 10px;
      border-bottom: 1px solid #eee;
      display: flex;
      align-items: center;
      .messageList-item-name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 380px;
      }
      .messageList-item-download {
        color: #1890ff;
      }
      .messageList-item-download {
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
  .messageList-item-download {
    color: #1890ff;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
  }

  .footer {
    width: 100%;
    cursor: pointer;
    text-align: right;
    margin-bottom: 10px;
  }
</style>
